import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

const Admin = lazy(() => import('@project/routes/pages/Admin'));

export const AdminRoutes = () => {
  return (
    <Routes>
      <Route index element={<Admin />} />
    </Routes>
  );
};
